'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2017/8/20.
                                          */

// import { LoadModal} from 'components';
// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _vrProductPage = require('redux/modules/vrProductPage');

var vrProductPageActions = _interopRequireWildcard(_vrProductPage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VrProductPage = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var params = _ref.params;

    var promises = [];
    promises.push(dispatch(vrProductPageActions.load(params.productId)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.vrProductPage.data
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VrProductPage, _Component);

  function VrProductPage() {
    (0, _classCallCheck3.default)(this, VrProductPage);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(VrProductPage).call(this));
  }

  (0, _createClass3.default)(VrProductPage, [{
    key: 'onBtnClick',
    value: function onBtnClick(productId) {
      // window.parent.location.href = 'http://www.craftschina.cn/product/' + productId;
      // top.location.href = 'http://www.craftschina.cn/product/' + productId;
      window.open('http://www.craftschina.cn/product/' + productId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;

      var styles = require('./VrProductPage.scss');
      var returnDiv = _react2.default.createElement('div', null);
      if (data) {
        (function () {
          var VRShoppingPage = data.VRShoppingPage;
          var VRShoppingPageError = data.VRShoppingPageError;

          if (VRShoppingPageError) {
            returnDiv = _react2.default.createElement(
              'div',
              null,
              VRShoppingPageError
            );
          } else if (VRShoppingPage) {
            returnDiv = _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', { src: VRShoppingPage[0].img, className: styles.img }),
              _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this2.onBtnClick(VRShoppingPage[0].id);
                  }, className: styles.backToHome },
                _react2.default.createElement('img', {
                  src: 'http://tupian.goeasy.cn:9999/yipinwang/third/more.png',
                  alt: '' })
              )
            );
          } else {
            returnDiv = _react2.default.createElement(
              'div',
              null,
              '服务器正忙，请刷新重试！'
            );
          }
        })();
      }
      return returnDiv;
    }
  }]);
  return VrProductPage;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = VrProductPage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/VrProductPage/VrProductPage.js
 ** module id = 1549
 ** module chunks = 0
 **/